'use client';

import * as a from "react";
import { IconContext as o } from "./context.es.js";
const p = a.forwardRef(
  (s, a$1) => {
    const {
      alt: n,
      color: r,
      size: t,
      weight: o$1,
      mirrored: c,
      children: i,
      weights: m,
      ...x
    } = s, {
      color: d = "currentColor",
      size: l,
      weight: f = "regular",
      mirrored: g = false,
      ...w
    } = a.useContext(o);
    return /* @__PURE__ */ a.createElement(
      "svg",
      {
        ref: a$1,
        xmlns: "http://www.w3.org/2000/svg",
        width: t != null ? t : l,
        height: t != null ? t : l,
        fill: r != null ? r : d,
        viewBox: "0 0 256 256",
        transform: c || g ? "scale(-1, 1)" : void 0,
        ...w,
        ...x
      },
      !!n && /* @__PURE__ */ a.createElement("title", null, n),
      i,
      m.get(o$1 != null ? o$1 : f)
    );
  }
);
p.displayName = "IconBase";
export {
  p as default
};
